import React, { createContext, useContext, useState, useCallback } from 'react';

export type HeaderMode = 'general' | 'hidden' | 'logo-language' | 'logo-lang-enquiry';
export type FooterMode = 'general' | 'hidden' | 'footer-only';

interface MinisiteLayoutState {
  headerMode: HeaderMode;
  footerMode: FooterMode;
  setLayout: (header: HeaderMode, footer: FooterMode) => void;
  resetLayout: () => void;
}

const MinisiteLayoutContext = createContext<MinisiteLayoutState>({
  headerMode: 'general',
  footerMode: 'general',
  setLayout: () => {},
  resetLayout: () => {},
});

export const useMinisiteLayout = () => useContext(MinisiteLayoutContext);

export const MinisiteLayoutProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const getInitialHeaderMode = (): HeaderMode => {
    if (typeof window !== 'undefined') {
      const path = window.location.pathname.replace(/\/$/, '');
      if (path === '/stb-hbomax') {
        return 'logo-language';
      }
    }
    return 'general';
  };

  const getInitialFooterMode = (): FooterMode => {
    if (typeof window !== 'undefined') {
      const path = window.location.pathname.replace(/\/$/, '');
      if (path === '/stb-hbomax') {
        return 'footer-only';
      }
    }
    return 'general';
  };

  const [headerMode, setHeaderMode] = useState<HeaderMode>(getInitialHeaderMode);
  const [footerMode, setFooterMode] = useState<FooterMode>(getInitialFooterMode);

  const setLayout = useCallback((header: HeaderMode, footer: FooterMode) => {
    setHeaderMode(header);
    setFooterMode(footer);
  }, []);

  const resetLayout = useCallback(() => {
    setHeaderMode('general');
    setFooterMode('general');
  }, []);

  return (
    <MinisiteLayoutContext.Provider value={{ headerMode, footerMode, setLayout, resetLayout }}>
      {children}
    </MinisiteLayoutContext.Provider>
  );
};
